import { Card } from "@/components/ui/card";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export default function MetricCard({ label, value, change, suffix, icon: Icon, className = "" }) {
  const changeNum = parseFloat(change);
  const isPositive = changeNum > 0;
  const isNegative = changeNum < 0;

  return (
    <Card className={`p-4 border border-border bg-card ${className}`} data-testid={`metric-${label?.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-xs text-muted-foreground uppercase tracking-wider font-medium">{label}</p>
          <p className="text-2xl font-semibold tracking-tight font-data">{value}</p>
        </div>
        {Icon && (
          <div className="p-2 rounded-sm bg-primary/10">
            <Icon size={18} className="text-primary" />
          </div>
        )}
      </div>
      {change != null && (
        <div className="flex items-center gap-1 mt-2">
          {isPositive ? (
            <TrendingUp size={14} className="text-emerald-500" />
          ) : isNegative ? (
            <TrendingDown size={14} className="text-red-500" />
          ) : (
            <Minus size={14} className="text-muted-foreground" />
          )}
          <span className={`text-xs font-data ${isPositive ? "text-emerald-500" : isNegative ? "text-red-500" : "text-muted-foreground"}`}>
            {isPositive ? "+" : ""}{change}{suffix || "%"} YoY
          </span>
        </div>
      )}
    </Card>
  );
}
